import React, { Component} from 'react';


export default class Trial extends Component{

    constructor(props){
        super(props)
        this.state={
            body:{
                username:String,
                mobile:Number,
                verifyCode:String,
                company:String,
                address:String,
                remark:String
            },
            getApi:String,
            postApi:String,
            haveCode:false,
            codeText:"获取验证码",
            img:require('./image/trial-neo.png'),
            getApiRed:"http://47.105.130.244:8080/zhlt-admin/sys/public/useApply/getCaptcha/",
            postApiRed:"http://47.105.130.244:8080/zhlt-admin/sys/public/useApply/create",
            getApiMengDuo:"https://zhlt-admin.mondonational.com/sys/public/useApply/getCaptcha/",
            postApiMengDuo:"https://zhlt-admin.mondonational.com/sys/public/useApply/create"

        }
    }
    componentDidMount(){
        if(global.constants.channel==="mengduo"){
            this.state.getApi=this.state.getApiMengDuo;
            this.state.postApi=this.state.postApiMengDuo;
            console.log(this.state.getApi)
        }else{
            this.state.getApi=this.state.getApiRed;
            this.state.postApi=this.state.postApiRed;
            console.log(this.state.getApi)
        }
    }
    
    isPhoneNumber(tel){
        var reg =/^0?1[3|4|5|6|7|8][0-9]\d{8}$/;
        return reg.test(tel);
    }
    
    getCode=async ()=>{
        
        if(this.isPhoneNumber(this.state.body.mobile)){
            const result = await fetch(this.state.getApi+this.state.body.mobile,{
                method:'GET',
                headers:{
                'Content-Type':'application/json',
                'Access-Control-Allow-Origin': '*'
                },
                mode:'cors',
            });
            console.log(result);
            const jsonResult = await result.json();
            console.log(jsonResult);
            if (jsonResult.msg=="success"){
                this.countDown(60)
                alert("验证码已发送，有效期为15分钟")
            }
        }else{
            alert("请输入正确的手机号")
        }
    }


    countDown(time){
        if (time===0) {
            this.setState({
                codeText:"获取验证码",
                haveCode:false
            })
            return
        }
        else{
            this.setState({
                haveCode:true,
                codeText:"已发送"+"("+time+")"
            })
            time--
        }
        setTimeout(()=>{
            this.countDown(time)},1000)
    }
     

    handleChange(key,value){
        
        console.log(key);
        console.log(value.target.value);
        
        this.setState({
            body:{
                ...this.state.body,[key]:value.target.value
            }
        },()=>{
            console.log(this.state.body);
        })
    }
   toTrial= async()=>{
        const trialResult = await fetch(this.state.postApi,{
            method:'POST',
            headers:{
                'Content-Type':'application/json',
                'Access-Control-Allow-Origin': '*'
                },
            body:JSON.stringify(this.state.body),
            mode:'cors',
       })
       console.log(JSON.stringify(this.state.body));
       console.log(trialResult);
       const trialJson = await trialResult.json();
       if (trialJson.msg=="success"){
        alert("已经申请成功")
        }
       debugger
       console.log(trialJson);
       
       
   }

    render(){
        var haveCode = this.state.haveCode
        return(
            <div className="trial">
                <div className="trialbox">
                    <div className="trialinput">
                        <div className="name01">
                            <input type="text" className="input"  placeholder="姓名" onChange={value => this.handleChange('username',value)} />
                        </div>
                        <div className="phone">
                            <input type="text" className="inputCode" placeholder="手机"  onChange={value => this.handleChange('mobile',value)}  />
                            <button className="needcode" 
                                    style={{
                                        background:(haveCode? "rgb(128,128,128)":"linear-gradient( to right,  rgb(51,95,222),rgb(89,164,251))"),
                                        padding:(haveCode? "0":"1px 7px 2px"),
                                       
                                    }} 
                                    onClick={this.getCode}
                                    disabled={haveCode}>
                                    {this.state.codeText}
                            </button>
                        </div>
                        <div className="code">
                            <input type="text" className="input toCode" style={{paddingLeft:"1rem",width:"12rem"}} placeholder="请输入验证码"  onChange={value => this.handleChange('verifyCode',value)}/>
                        </div>
                        <div className="company">
                            <input type="text" className="input" placeholder="公司"  onChange={value => this.handleChange('company',value)} />
                        </div>
                        <div className="address">
                            <input type="text" className="input" placeholder="地址" onChange={value => this.handleChange('address',value)} />
                        </div>
                        <div className="reference">
                            <textarea type="text" className="textarea" style={{resize:"none"}} placeholder="备注" onChange={value => this.handleChange('remark',value)} />
                        </div>
                        <button className="enter" onClick={this.toTrial}>提交申请</button>
                        <img src={this.state.img} className="neo"/>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Trial.js